import { Alert, Typography } from 'antd';
import { AjaxTable, CustomButton } from '../../components';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import { Link } from 'react-router-dom';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import { contractsTable } from '../../api/module/ct_certifications_contractor';

const { Title, Text } = Typography;
const breadcrumbItems = [
  {
    text: 'Certificaciones',
  },
];

const CTCertificationsContractor = () => {
  const columns = [
    {
      title: 'Entidad contratante',
      dataIndex: 'organizacion_nombre',
    },
    {
      title: 'Proyecto',
      dataIndex: 'proyecto',
    },
    {
      title: 'No. Contrato',
      dataIndex: 'contrato_num',
      width: '6em',
    },
    {
      title: 'Cargo',
      dataIndex: 'rol',
      width: '20em',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: '12em',
      render: (_, record) => (
        <Link
          to={`${INTERNAL_LINKS.CONTRACTOR_CT_SPECIFIC_CERTIFICATIONS}/${record.pk}`}
        >
          <CustomButton
            text="Certificaciones"
            htmlType="button"
            block
            type="default"
          />
        </Link>
      ),
    },
  ];
  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        CERTIFICACIONES
      </Title>
      <Text>
        A continuación se muestra la lista de los contratos en los que ha
        participado
      </Text>
      <br />
      <br />
      <Alert
        type="info"
        showIcon
        message="Información importante"
        description={
          <>
            <Text>
              Si desea generar una certificación donde se incluya más de un
              contrato de la misma entidad contratante, haga clic en el
              siguiente botón:
            </Text>
            <br />
            <Link to={`${INTERNAL_LINKS.CONTRACTOR_CT_GENERAL_CERTIFICATIONS}`}>
              <CustomButton htmlType="button" text="Certificación general" />
            </Link>
          </>
        }
      />
      <AjaxTable
        tableTitle="Listado de contratos"
        columns={columns}
        endpoint={contractsTable}
        searchInput
        exportCSV
      />
    </>
  );
};

export default CTCertificationsContractor;
